// extracted by mini-css-extract-plugin
export var orderDetails = "_ok-2";
export var orderImage = "_ok-1";
export var orderMeta = "_ok-3";
export var orderSummary = "_ok-0";
export var rightArrow = "_ok-4";